import HelloWorld from './HelloWorld.vue';
import Loader from './Loader.vue';
import SvgSeats from './SvgSeats.vue';
import SvgBlocks from './SvgBlocks.vue';
import SvgModal from './SvgModal.vue';
import SearchForm from './SearchForm.vue';
import SearchUser from './SearchUser.vue';
import CounterInput from './CounterInput.vue';
import PayMethods from './PayMethods.vue';
import Voucher from './Voucher.vue';
import VoucherPoint from './VoucherPoint.vue';
import TicketPrint from './TicketPrint.vue';

import EventsList from './EventsList.vue';
import CartEvents from './CartEvents.vue';
import UserDataBuyEvents from './UserDataBuyEvents.vue';

import ProductsCourtesy from './ProductsCourtesy.vue';

import CardProduct from './CardProduct.vue';
import ProductsList from './ProductsList.vue';
import CartProducts from './CartProducts.vue';
import FormPay from './products/FormPay.vue';
import UnilabsForms from './UnilabsForms.vue';
import Counter from './Counter.vue';
import DeliveryAddress from './DeliveryAddress.vue';
import FormAddress from './FormAddress.vue';

import Coupon from './shared/Coupon.vue';
import PayByEvent from './shared/PayByEvent.vue';
import ProductVariations from './shared/ProductVariations.vue';
import ModalCustomize from './shared/ModalCustomize.vue';

import Addresses from './Addresses.vue';
import CardAddress from './shared/CardAddress.vue';
import ModalAddress from './shared/ModalAddress.vue';
import Client from './shared/Client.vue';
import Dates from './shared/Dates.vue';
import SummaryDelivery from './shared/SummaryDelivery.vue';

import Map from './shared/map/Map.vue';
import ModalPaymentQR from './ModalPaymentQR.vue';

import Shopping from './shopping/Shopping.vue';
import CardPaymentInQuotas from './shopping/CardPaymentInQuotas.vue';
import CardTotalPayment from './shopping/CardTotalPayment.vue';
import ModalPayRemainingParts from './shopping/ModalPayRemainingParts.vue';

import UserDataBuyBilling from './UserDataBuyBilling.vue';

import CardDetailsBuyer from './shopping/CardDetailsBuyer.vue';

import ModalBilling from './shared/ModalBilling.vue';
import LoadingJoinnus from './shared/LoadingJoinnus.vue';
import CardProfile from './shared/CardProfile.vue';
// TODO: components from machupicchu
import DatePicker from 'vue2-datepicker';

const components = {
  Addresses,
  CardAddress,
  ModalAddress,
  Dates,
  HelloWorld,
  Loader,
  SvgSeats,
  SvgBlocks,
  SvgModal,
  SearchForm,
  SearchUser,
  CounterInput,
  PayMethods,
  Voucher,
  TicketPrint,
  EventsList,
  CartEvents,
  UserDataBuyEvents,
  ProductsCourtesy,
  CardProduct,
  ProductsList,
  CartProducts,
  FormPay,
  VoucherPoint,
  UnilabsForms,
  Counter,
  DeliveryAddress,
  FormAddress,
  Coupon,
  PayByEvent,
  ProductVariations,
  ModalCustomize,
  Map,
  Client,
  SummaryDelivery,
  ModalPaymentQR,
  CardTotalPayment,
  CardPaymentInQuotas,
  Shopping,
  ModalPayRemainingParts,
  UserDataBuyBilling,
  CardDetailsBuyer,
  ModalBilling,
  LoadingJoinnus,
  CardProfile,
  DatePicker
};

components.install = (Vue) => {
  // Register components
  Object.keys(components).forEach((componentName) => {
    const component = components[componentName];
    if (component && componentName !== 'install') {
      Vue.component(componentName, component);
    }
  });
};

export default components;
